/** O aviso de "confirme seu e-mail" (SPEC-IDN-014).
 *
 * **Avisa, não bloqueia.** Nenhuma tela exige o e-mail confirmado, e é
 * deliberado: barrar o produto até o clique transformaria um endereço digitado
 * errado — ou um e-mail que caiu em spam — em conta inutilizável no primeiro
 * minuto de uso, que é o pior momento possível. O que se perde sem confirmar é
 * a recuperação de senha e os avisos do dia, e o texto diz isso.
 *
 * Dispensável de propósito. Um aviso permanente que não se pode calar vira
 * ruído, e ruído permanente ensina a ignorar o próximo aviso — inclusive os que
 * importam. Dispensar vale para a aba: recarregar o traz de volta, porque o
 * problema continua lá.
 */

import { useState } from "react";

import { ApiError } from "@/lib/http";

import { reenviarVerificacao } from "./api";

type Envio = "parado" | "enviando" | "enviado" | "falhou";

export function AvisoDeVerificacao({ email }: { email?: string }) {
  const [dispensado, setDispensado] = useState(false);
  const [envio, setEnvio] = useState<Envio>("parado");

  if (dispensado) return null;

  async function reenviar() {
    setEnvio("enviando");
    try {
      await reenviarVerificacao();
      setEnvio("enviado");
    } catch (falha) {
      setEnvio("falhou");
      if (!(falha instanceof ApiError)) throw falha;
    }
  }

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-borda bg-ambar/10 px-6 py-3"
    >
      {/* O ícone acompanha o texto; nunca o substitui (DESIGN.md § 8). */}
      <span aria-hidden className="text-ambar">
        ●
      </span>
      <p className="font-texto text-caption text-texto">
        {/* O endereço por extenso e a explicação ficam para telas maiores: no
            celular a faixa ocupava três linhas antes de qualquer conteúdo, e
            quem acabou de se cadastrar sabe qual é o próprio e-mail. */}
        Confirme seu e-mail
        <span className="hidden sm:inline">
          {email === undefined ? "" : ` (${email})`} para poder recuperar a senha e receber os
          avisos do seu dia.
        </span>
      </p>

      {envio === "enviado" ? (
        <span className="font-texto text-caption text-musgo">Link reenviado. Olhe sua caixa.</span>
      ) : (
        <button
          type="button"
          onClick={() => void reenviar()}
          disabled={envio === "enviando"}
          className="font-texto text-caption font-medium text-acao underline underline-offset-2 disabled:opacity-60"
        >
          {envio === "enviando" ? "Enviando…" : "Reenviar o link"}
        </button>
      )}

      {envio === "falhou" && (
        <span className="font-texto text-caption text-carmim">
          Não foi possível reenviar agora. Tente daqui a pouco.
        </span>
      )}

      <button
        type="button"
        onClick={() => {
          setDispensado(true);
        }}
        aria-label="Dispensar o aviso"
        className="ml-auto font-texto text-caption text-texto-suave hover:text-texto"
      >
        Dispensar
      </button>
    </div>
  );
}
